import React from 'react'
import PropTypes from 'prop-types'
import { Empty, Table } from 'antd'
import { changeSentence } from './utils'

// The last twenty route changes, who made them and when.
//
// A route decides where a customer's money goes, so "tracking's mobile money moved to Bachs on
// Tuesday" is the first thing anybody will want to know when a day's settlements look wrong. The
// server writes one row per FIELD changed rather than per save, which is why an edit that switched
// a rail off AND moved it appears here as two lines: they were two decisions.
const columns = [
  {
    title: 'When',
    dataIndex: 'at',
    key: 'at',
    render: at => (at ? new Date(at).toLocaleString() : '—')
  },
  {
    title: 'Change',
    key: 'change',
    render: (_text, row) => changeSentence(row)
  },
  {
    title: 'By',
    dataIndex: 'by',
    key: 'by',
    // A dash rather than an empty cell: a change with nobody's name on it was made by a script or
    // before the log carried one, and a blank reads as a rendering bug.
    render: by => by || '—'
  }
]

const RecentChanges = ({ changes }) =>
  (changes || []).length ? (
    <Table
      size="small"
      rowKey={(row, index) => `${row.at}-${row.field}-${index}`}
      columns={columns}
      dataSource={changes}
      pagination={false}
    />
  ) : (
    <Empty description="No route has been changed yet." />
  )

RecentChanges.propTypes = {
  changes: PropTypes.array
}

export default RecentChanges
